import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import ShelfProduct from "components/ShelfProduct";
import TagManager from "services/TagManager";
import style from './style.scss'; //NOSONAR

const ProductOffers = (props) => {
    
    const products = props.products ? props.products : [] ;
    let arrayProds = products.map((prod) => {
        let product = {...prod[1]};
        delete product.pos;
        return product;
    });

    useEffect(()=>{
        TagManager.productImpressions(arrayProds, `Vitrina ${props.shelfIsland}`);
    },[])
    
    return products.map((element, i)=>{
        const item = (element[0] && element[0].product) ? element[0].product[0] : null;
        const product = element[1] ? element[1] : {};
        if (!product && product.length === {} ) return '';

        return (
            <section className={"principal-container-product-offers" + (item.time ? ' with-time' : '')} key={i}>
                <ShelfProduct product={product} item={item} position={i} listTitle={`Vitrina ${props.shelfIsland}`}/>
            </section>
        );
    })
   
};

ProductOffers.propTypes = {
    products: PropTypes.array,
    item: PropTypes.object,
    name: PropTypes.string,
    shelfIsland: PropTypes.number
};

export default ProductOffers;
